/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as NotificationDefs from './defs.defs.js'

const $nsid = 'app.bsky.notification.putActivitySubscription'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  subject: /*#__PURE__*/ l.string({ format: 'did' }),
  activitySubscription:
    /*#__PURE__*/ l.ref<NotificationDefs.ActivitySubscription>(
      (() => NotificationDefs.activitySubscription) as any,
    ),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  subject: /*#__PURE__*/ l.string({ format: 'did' }),
  activitySubscription: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<NotificationDefs.ActivitySubscription>(
      (() => NotificationDefs.activitySubscription) as any,
    ),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Puts an activity subscription entry. The key should be omitted for creation and provided for updates. Requires auth. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
